'use client';

import type { Locale } from '@fixter/i18n/locale';
import dynamic from 'next/dynamic';
import { useModalQueue } from '$util/hooks/useModalQueue';
import { Button } from '@/components/atoms/Button';
import { LoadingIndicator } from '@/components/atoms/LoadingIndicator';
import type { VrmLookupBlogData } from '@/components/molecules/VrmLookupBlog';

import styles from './index.module.scss';

/**
 * @note Dynamically import to reduces bundle size because it's needed only after user interaction.
 */
const VrmLookupBlog = dynamic(
  () =>
    import('../../molecules/VrmLookupBlog').then((mod) => {
      return mod.VrmLookupBlog;
    }),
  {
    loading: () => (
      <div className={styles.loadingContent}>
        <LoadingIndicator />
      </div>
    ),
  }
);

export interface VrmLookupBlogModalProps {
  readonly locale: Locale;
  readonly toggleButtonText: string;
  readonly data: VrmLookupBlogData;
}

export default function VrmLookupBlogModal({
  locale,
  toggleButtonText,
  data,
}: VrmLookupBlogModalProps): JSX.Element {
  const [, queueModal] = useModalQueue();

  const toggleModal: React.MouseEventHandler = () => {
    queueModal([
      <VrmLookupBlog
        key="VrmLookupBlog.VrmLookupBlogModal"
        id="VrmLookupBlog.VrmLookupBlogModal"
        locale={locale}
        data={data}
      />,
      'modal',
    ]);
  };

  return <Button onClick={toggleModal}>{toggleButtonText}</Button>;
}

VrmLookupBlogModal.displayName = 'VrmLookupBlogModal';
